import { authUserSchema, type AuthUser } from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { ApiRequestError, apiFetch } from '@/lib/api';

export const meQueryKey = ['auth', 'me'] as const;

export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: async (): Promise<AuthUser | null> => {
      try {
        return await apiFetch('/auth/me', authUserSchema);
      } catch (error) {
        if (error instanceof ApiRequestError && error.error.statusCode === 401) {
          return null;
        }
        throw error;
      }
    },
    retry: false,
    refetchOnWindowFocus: true,
    refetchInterval: (query) => (query.state.data ? 12 * 60 * 1000 : false),
  });
}
